<div class="column has-text-centered">
  <span class="img-row" *ngFor="let image of files; let i=index">
    <ng-container *ngIf="image.src">
      <img class="img-frame" #row (contextmenu)="cm.show($event);selectFile(image.src);"
        *ngIf="image.src.toLocaleLowerCase().includes('.heif') || image.src.toLocaleLowerCase().includes('.heic') || image.src.toLocaleLowerCase().includes('.png') || image.src.toLocaleLowerCase().includes('.bmp') || image.src.toLocaleLowerCase().includes('.jpg') || image.src.toLocaleLowerCase().includes('.jpeg') || image.src.toLocaleLowerCase().includes('.svg') "
        [src]="image.thumb" (click)="open(image.src)" pTooltip="{{image.src | fileName}}" tooltipPosition="right" />
                                   
      <i *ngIf="image.src.toLocaleLowerCase().includes('.docx') || image.src.toLocaleLowerCase().includes('.xlsx') ||  image.src.toLocaleLowerCase().includes('.pptx') ||  image.src.toLocaleLowerCase().includes('.ppt') ||  image.src.toLocaleLowerCase().includes('.xls') || image.src.toLocaleLowerCase().includes('.doc')"
        class="fa fa-file img-frame" #row1 (contextmenu)="cm.show($event);selectFile(image.src);"
        (click)="downloadFile(image.src);" pTooltip="{{image.src | fileName}}" tooltipPosition="right"
        aria-hidden="true"></i>
        <i *ngIf="image.src.toLocaleLowerCase().includes('.pdf')"
                      class="fa fa-file-pdf-o img-frame" #row1
                      (click)="showDialog(image.src,image.caption)">
                      </i>
    </ng-container>
  </span>
</div>     
<p-contextMenu appendTo="body" [target]="row" #cm [model]="contextItems"></p-contextMenu>
                                                                                          
<p-dialog  header="Preview" [(visible)]="displayFile" [style]="{width: '60vw', top: '20px'}">
          
  <div class="pdfbody" style="height: 41vw">
    <div style="margin: 10px !important;">
      <button type="button" class="btn btn-primary primary-btn" (click)="downloadPDFFile(PreviewUrl,FileName);">
        <i class="fa fa-download"></i> Download
      </button>
      <span class="padding-left-5">
        <button class="btn btn-default" (click)="zoomPrev(0)">-</button>
        <button class="btn btn-default" (click)="zoomPrev(1)">+</button>
      </span>
    </div>
    <pdf-viewer [src]="PreviewUrl" [zoom]="Zoom" [render-text]="true" style="display: block;">
    </pdf-viewer>
    <!-- <ngx-doc-viewer [url]="PreviewUrl"  style="width:90%;height:90%;" viewer="google" ></ngx-doc-viewer> -->
  </div>
</p-dialog>
